"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _commonConstants = require("../../../utils/common-constants");

var _constants = require("./constants");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  status: _commonConstants.RESOURCE_STATUS.INITIAL,
  error: null,
  data: {}
};
var clonePermissionListInitialState = {
  status: _commonConstants.RESOURCE_STATUS.INITIAL,
  error: null,
  data: []
};

var permissionList = function permissionList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : clonePermissionListInitialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _constants.clonePermissionsListType.RECURSIVE_CLONE_PERMISSIONS_LIST_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.LOADING,
        data: []
      });

    case _constants.clonePermissionsListType.RECURSIVE_CLONE_PERMISSIONS_LIST_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        data: [].concat(_toConsumableArray(state === null || state === void 0 ? void 0 : state.data), _toConsumableArray(action === null || action === void 0 ? void 0 : action.payload))
      });

    case _constants.clonePermissionsListType.RECURSIVE_CLONE_PERMISSIONS_LIST_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.ERROR,
        error: action.payload
      });

    case _constants.clonePermissionsListType.RECURSIVE_CLONE_PERMISSIONS_LIST_LOADING_DISABLE:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.SUCCESS
      });

    case _constants.clonePermissionsListType.RECURSIVE_CLONE_PERMISSIONS_LIST_RESET:
      return _objectSpread({}, clonePermissionListInitialState);

    default:
      return state;
  }
};

var permissionActionsList = function permissionActionsList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _constants.ClonePermissionActionsType.CLONE_PERMISSION_ACTIONS_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.LOADING
      });

    case _constants.ClonePermissionActionsType.CLONE_PERMISSION_ACTIONS_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.SUCCESS,
        data: _objectSpread({}, action.payload)
      });

    case _constants.ClonePermissionActionsType.CLONE_PERMISSION_ACTIONS_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.ERROR,
        error: action.payload
      });

    case _constants.ClonePermissionActionsType.PERMISSION_ACTIONS_RESET:
      return _objectSpread({}, initialState);

    default:
      return state;
  }
};

var permissionDetails = function permissionDetails() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _constants.ClonePermissionDetailsType.CLONE_PERMISSION_DETAILS_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.LOADING,
        data: null
      });

    case _constants.ClonePermissionDetailsType.CLONE_PERMISSION_DETAILS_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.SUCCESS,
        data: _objectSpread({}, action.payload)
      });

    case _constants.ClonePermissionDetailsType.CLONE_PERMISSION_DETAILS_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.ERROR,
        error: action.payload
      });

    default:
      return state;
  }
};

var cloneRoleInitialState = {
  status: _commonConstants.RESOURCE_STATUS.INITIAL,
  error: null,
  data: []
};

var rolesList = function rolesList() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : cloneRoleInitialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _constants.cloneRolesListType.RECURSIVE_CLONE_ROLES_LIST_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.LOADING,
        data: []
      });

    case _constants.cloneRolesListType.RECURSIVE_CLONE_ROLES_LIST_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        data: [].concat(_toConsumableArray(state === null || state === void 0 ? void 0 : state.data), _toConsumableArray(action.payload))
      });

    case _constants.cloneRolesListType.RECURSIVE_CLONE_ROLES_LIST_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.ERROR,
        error: action.payload
      });

    case _constants.cloneRolesListType.RECURSIVE_CLONE_ROLES_LIST_LOADING_DISABLE:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.SUCCESS
      });

    case _constants.cloneRolesListType.RECURSIVE_CLONE_ROLES_LIST_RESET:
      return _objectSpread({}, cloneRoleInitialState);

    default:
      return state;
  }
};

var roleDetails = function roleDetails() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _constants.CloneRolesDetailsType.CLONE_ROLES_DETAILS_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.LOADING
      });

    case _constants.CloneRolesDetailsType.CLONE_ROLES_DETAILS_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.SUCCESS,
        data: _objectSpread({}, action.payload)
      });

    case _constants.CloneRolesDetailsType.CLONE_ROLES_DETAILS_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.ERROR,
        error: action.payload
      });

    default:
      return state;
  }
};

var loadPolicy = function loadPolicy() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _constants.LoadPolicyDataType.CLONE_LOAD_POLICY_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.LOADING,
        error: null
      });

    case _constants.LoadPolicyDataType.CLONE_LOAD_POLICY_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.SUCCESS,
        data: action.payload,
        error: null
      });

    case _constants.LoadPolicyDataType.CLONE_LOAD_POLICY_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.ERROR,
        error: action.payload
      });

    case _constants.LoadPolicyDataType.CLONE_LOAD_POLICY_RESET:
      return _objectSpread({}, initialState);

    default:
      return state;
  }
};

var loadPolicyJSON = function loadPolicyJSON() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _constants.LoadPolicyDataType.CLONE_LOAD_POLICY_JSON_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.LOADING,
        error: null
      });

    case _constants.LoadPolicyDataType.CLONE_LOAD_POLICY_JSON_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.SUCCESS,
        data: action.payload,
        error: null
      });

    case _constants.LoadPolicyDataType.CLONE_LOAD_POLICY_JSON_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.ERROR,
        error: action.payload
      });

    case _constants.LoadPolicyDataType.CLONE_LOAD_POLICY_JSON_RESET:
      return _objectSpread({}, initialState);

    default:
      return state;
  }
};

var addPolicy = function addPolicy() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _constants.ClonePolicyType.CLONE_POLICY_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.LOADING,
        error: null
      });

    case _constants.ClonePolicyType.CLONE_POLICY_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.SUCCESS,
        data: _objectSpread({}, action.payload.result),
        error: null
      });

    case _constants.ClonePolicyType.CLONE_POLICY_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.ERROR,
        error: action.payload
      });

    default:
      return state;
  }
};

var clonePolicyReducer = (0, _redux.combineReducers)({
  permissionList: permissionList,
  permissionActionsList: permissionActionsList,
  permissionDetails: permissionDetails,
  rolesList: rolesList,
  roleDetails: roleDetails,
  loadPolicy: loadPolicy,
  loadPolicyJSON: loadPolicyJSON,
  addPolicy: addPolicy
});
var _default = clonePolicyReducer;
exports.default = _default;